// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2ftHr","fileBtn":"File_fileBtn__27AAP","closeBtn":"File_closeBtn__2I6vJ","fileSelected":"File_fileSelected__2b_FT","disabled":"File_disabled__2wb-w"};